<template>
  <div class="attachment d-flex flex-row mb-2" :class="{ 'attachment-error': error }">
    <div class="attachment-name" :class="{ 'attachment-color-error': error }" @click.stop="onAttachmentClick">
      <span :class="{ 'attachment-color-error': error }">{{ fileName }}</span>
    </div>
    <v-icon
      v-if="close"
      small
      :class="{ 'close-icon': true, 'attachment-color-error': error }"
      @click.stop="closeClick"
    >
      mdi-close
    </v-icon>
  </div>
</template>

<script>
export default {
  name: 'EcsEmailAttachment',
  props: {
    file: {
      type: [File, Object],
      required: true
    },
    fileName: {
      type: String,
      default: ''
    },
    contentType: {
      type: String,
      default: ''
    },
    close: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    attachmentId: {
      type: String,
      default: ''
    }
  },
  methods: {
    onAttachmentClick() {
      this.$emit('attachmentClick', this.file);
    },
    closeClick(e) {
      this.$emit('attachmentClose', this.attachmentId);
    }
  }
};
</script>

<style scoped>
.attachment {
  background-color: var(--v-surface-base);
  padding: 4px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  cursor: pointer;
  margin-right: 8px;
  border-radius: 4px;
  max-width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  align-items: center;
  white-space: nowrap;
  height: 40px;
}
.attachment:hover {
  background-color: var(--v-surface-darken1);
}
.attachment-name {
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 18px;
}
.attachment-error {
  border: solid 1px var(--v-error-base);
}
.attachment-color-error {
  color: var(--v-error-base);
}
.close-icon {
  margin-left: 8px;
}
</style>
